import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

/**
 * Protegge una route richiedendo che l'utente sia autenticato.
 * Se non autenticato → redirect a "/" con salvataggio della
 * posizione corrente, così dopo il login si torna alla pagina voluta.
 *
 * Mostra uno spinner durante il controllo iniziale della sessione.
 */
const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Attendi il ripristino della sessione da localStorage
  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '60vh' }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Caricamento...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Salva la pagina richiesta per il redirect post-login
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
